export default function COrganizeCode() {
  return <h2>C Organize Code</h2>;
}
